import { createSlice } from '@reduxjs/toolkit';
import type { Entitlements } from '~/redux/api/routes/subscriptions/models';

interface EntitlementsState {
  data: Entitlements;
  isLoaded: boolean;
}

const initialState: EntitlementsState = {
  data: [],
  isLoaded: false,
};

const entitlementsSlice = createSlice({
  name: 'entitlements',
  initialState,
  reducers: {
    setEntitlements(state, action) {
      if (Array.isArray(action.payload.entitlements)) {
        state.data = action.payload.entitlements;
        state.isLoaded = true;
      }
    },
  },
});

export const { setEntitlements } = entitlementsSlice.actions;
export default entitlementsSlice.reducer;
